<template>
  <div>
    <ListCard
      is-table
      white
      no-padding
      :card-list="auditerList"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      auditerList: [
          {
            type: "text",
            title: "稽核總評",
            text: "稽核者總評文字內容，稽核者總評文字內容，稽核者總評文字內容，稽核者總評文字內容，稽核者總評文字內容，稽核者總評文字內容，稽核者總評文字內容，稽核者總評文字內容。",
          },
          {
            type: "multiple",
            list: [
              {
                type: "avatar",
                title: "稽核者",
                name: "王大明",
                avatarImage: "",
              },
              {
                type: "text",
                title: "稽核時間",
                text: "2020.05.13 14:34",
              },
            ],
          },
        ],
    }
  }
}
</script>

<style>

</style>